import * as types from "./constants/types.js";
import Cookie from "js-cookie";
import Vue from "vue";

export default {
    /**
     * 获取字典
     * @param {String} p.t 字典类型
     * @param {Array} p.list 字典列表
     */
    [types.GET_DICT](state, p) {
        state["dict"][p.t] = p.list;
    },
    /**
     * 确认选择地址
     * @param {String} p.t 地址类型
     * @param {Array} p.list 地址列表
     */
    confirmSend(state, list) {

        state.sendList = JSON.parse(JSON.stringify(list))
    },
    confirmAccept(state, list) {

        state.acceptList = JSON.parse(JSON.stringify(list))
    },

    confirmSends(state, list) {
        state.sendLists = JSON.parse(JSON.stringify(list))
    },
    confirmAccepts(state, list) {
        state.acceptLists = JSON.parse(JSON.stringify(list))
    },
    /**
     * 删除选中地址
     * @param {String} p.t 地址类型
     * @param {Number} p.index 索引
     */
    uncheckSend(state, item) {
        state.sendList.forEach((val, i) => {
            if (val.id === item.id) {
                state.sendList.splice(i, 1)
            }
        })
    },
    uncheckAccept(state, item) {
        state.acceptList.forEach((val, i) => {
            if (val.id === item.id) {
                state.acceptList.splice(i, 1)
            }
        })
    },
    /**
     * 删除地址
     * @param {String} p.t
     * @param {Object} p.address
     * @param {Number} p.index
     */
    [types.DEL_ADDRESS](state, p) {
        if (p.t === "1") {
            state.sendList.splice(p.index, 1);
        } else if (p.t === "2") {
            state.acceptList.splice(p.index, 1);
        }
    },
    /**
     * 修改地址
     * @param {String} p.id 地址ID
     * @param {String} p.index 地址索引
     */
    [types.MODIFY_ADDRESS](state, p) {
        if (p.t === "1") {
            Vue.set(state.sendList, p.index, p.address);
        } else if (p.t === "2") {
            Object.keys(state.acceptList[p.index]).forEach(key => {
                if (p.address[key]) {
                    Vue.set(state.acceptList, p.index, p.address);
                }
            });
        }
    },
    // 登录
    [types.GET_TOKEN](state) {
        let yhb_token =
            localStorage.getItem("yhb_token") || Cookie.get("yhb_token");
        state.token = JSON.parse(yhb_token).token;
        let mobile = localStorage.getItem("yhb_phone") || Cookie.get("yhb_phone");
        state.mobile = mobile;
    },
    // 未授权
    [types.LOGOUT](state) {
        state.token = null;
        localStorage.removeItem("yhb_token");
        Cookie.remove("yhb_token");
        state.mobile = null;
        localStorage.removeItem("yhb_phone");
        Cookie.remove("yhb_token");
    },
    [types.SET_META](state, {title, hideNav, hideBack}) {
        state.title = title
        state.hideNav = hideNav
        state.hideBack = hideBack
    },
    [types.SET_TITLE](state, p) {
        state.title = p.title;
    },
    top(state, data) {
        state.top = data.top
        state.height = data.height
    },
    getOpenid(state, id) {
        state.openid = id
    },
    hanldheaderShow(state, show) {
        state.headerShow = show
    },
    setPath(state, path) {
        state.toPath = path
    },
    setMapTitle(state, mapTitle) {
        state.mapTitle = mapTitle
    }
};
